import * as ACTION from '../actions/actionTypes';
import { UpdateObject } from '../../utils/utils';

const initialState = {
    loading: false,
    errorMsg: '',
    data:[],
   // calendarData:[]
}

const RcuKeyCodesReducer = (state = initialState, action) => {
    switch(action.type) {
       
        case ACTION.GET_RCU_KEY_CODES_REQUEST: return getRcuKeyCodesRequest(state, action);
        case ACTION.GET_RCU_KEY_CODES_SUCCESS: return getRcuKeyCodesSuccess(state, action);
        case ACTION.GET_RCU_KEY_CODES_FAILURE: return getRcuKeyCodesFailure(state, action);
        
        default: return state;
    }
}

const getRcuKeyCodesRequest = (state, action) => {
    return UpdateObject(state, {
        loading: true,
    });
}
const getRcuKeyCodesSuccess = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        data: action.payload,
    });
}
const getRcuKeyCodesFailure = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        errorMsg: action.payload,
    });
}

export default RcuKeyCodesReducer;